export function ExportEmailVehicleCtrl (
  $uibModalInstance,
  $scope,
  $translate,
  company,
  limited,
  messages,
  workshopAPI
) {

  $scope.company     = company;
  $scope.export_type = $translate.instant('VEHICLE_SPACE.VEHICLE');
  $scope.limited     = limited;

  $scope.email_export = function () {
    const url = $scope.limited ? '/vehicles/vehicle_csv_customer_export'  : '/vehicles/vehicle_csv_admin_export';

    workshopAPI.post(url, {
      email: $scope.email,
      company_id: $scope.company.id
    }, 'vehicle_data').then(() => {
      messages.show($translate.instant('EXPORT_SPACE.EXPORT_EMAIL_CONFIRM', {email: $scope.email}), 'success');
      $uibModalInstance.close();
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss();
  };
}